import { Card } from '@skf-internal/ui-components-react-legacy';

const BearingTypeResult = () => {
  return <Card>Bearing Type Result will be here</Card>;
};

export default BearingTypeResult;
